import { useCallback, useState } from 'react';
import { CampaignConfigSchema } from '../types';
import { initialConfig } from '../helpers';
import { HeaderFieldType } from '../components/ConfigurationHeader/ConfigurationHeader';

export type SelectedFieldType = HeaderFieldType | 'groups' | 'keywords' | 'appointmentType' | 'contactDate';

/**
 * Owns the editable CampaignConfigSchema state and the currently-selected field.
 * Type-change side effects (visibility defaults, opt-out) are applied by
 * ConfigurationHeader via helpers/applyTypeDefaults, so updateConfig is a plain
 * shallow merge.
 */
export const useCampaignConfigState = () => {
  const [config, setConfig] = useState<CampaignConfigSchema>(() => ({
    ...initialConfig,
    updatedAt: new Date().toISOString(),
  }));
  const [selectedField, setSelectedField] = useState<SelectedFieldType | null>(null);

  const updateConfig = useCallback((updates: Partial<CampaignConfigSchema>) => {
    setConfig(prev => ({ ...prev, ...updates }));
  }, []);

  return { config, setConfig, selectedField, setSelectedField, updateConfig };
};
